<template>
  <WsMain>
    <template v-if="loading.fetch">
      <v-skeleton-loader
        v-for="n in 4"
        :key="`skeleton-${n}`"
        type="list-item-three-line"
        :tile="true"
        class="mt-5"
      ></v-skeleton-loader>
    </template>
    <template v-else>
      <WsMultiList
        v-if="state&&state.length"
        :value="state"
        v-bind="fields"
      >
      </WsMultiList>
      <template v-else>
        <WsTitle>尚未有工廠訂閱此法規</WsTitle>
      </template>
    </template>
  </WsMain>
</template>
<script>
export default {
  data() {
    return {
      state: [],
      loading: {
        fetch: false,
      },
      fields: {
        textKey: "name",
        icon: "mdi-domain",
        subIcon: "mdi-factory",
        iconControlKey: "child_factories",
        layerFields: [
          {
            modelKey: "child_factories",
            textKey: "name",
            icon: "mdi-domain",
            subIcon: "mdi-factory",
            iconControlKey: "child_factories",
            innerFields: [
              {
                modelKey: "factories",
                textKey: "name",
                icon: "mdi-factory",
              },
            ],
          },
          {
            modelKey: "factories",
            textKey: "name",
            icon: "mdi-factory",
          },
        ],
      },
    };
  },
  computed: {
    _currentActId() {
      return this.$route.params.id
    }
  },
  mounted() {
    this.$_fetchData();
  },
  methods: {
    async $_fetchData() {
      try {
        this.loading.fetch = true;
        const act = await this.$axios.get(`/act/${this._currentActId}`)
        const subscriptionFactoryIds = act.data.data.subscription_factory_ids.toString()
        const params = {
          factories: subscriptionFactoryIds,
          get_all: 1,
        };
        const subscribedFactories = await this.$axios.get(`/factory_check`, {params});
        this.state = this.$_setColorForSubscribeFactories(subscribedFactories.data.data, subscriptionFactoryIds);
        this.loading.fetch = false;
      } catch (err) {
        this.loading.fetch = false;
      }
    },
    $_setColorForSubscribeFactories(layers, subscriptionFactoryIds) {
      layers.forEach(layer => {
        if (subscriptionFactoryIds.includes(layer.id)) {
          layer.bgColor = 'blue'
          layer.textColor = 'white--text'
        }
        if (layer.child_factories.length) {
          layer.child_factories = this.$_setColorForSubscribeFactories(layer.child_factories, subscriptionFactoryIds)
        }
      })
      return layers
    }
  },
};
</script>